const normalizeWord = (text: string) =>
  text.replace(/[|\s]/g, "").toUpperCase();

export default normalizeWord;